module.exports = new __parcel__URL__("recognizer-processor.2ad709db.js").toString();